import { render, staticRenderFns } from "./NewSimulationSingleCompete.vue?vue&type=template&id=2fcb39a7&scoped=true&"
import script from "./NewSimulationSingleCompete.vue?vue&type=script&lang=js&"
export * from "./NewSimulationSingleCompete.vue?vue&type=script&lang=js&"
import style0 from "./NewSimulationSingleCompete.vue?vue&type=style&index=0&id=2fcb39a7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fcb39a7",
  null
  
)

export default component.exports